import { render, staticRenderFns } from "./label-printing-list.vue?vue&type=template&id=aafdf0ee"
import script from "./label-printing-list.vue?vue&type=script&lang=js"
export * from "./label-printing-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports